<template>
	<tr v-if="item">
		<loading :active="loading">
			<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
		</loading>
		<td>
			<template v-if="editMode">
				<div class="form-group" :class="{ 'has-error' : errors.has('name') }">
					<input
						name="name"
						v-validate="'required'"
						data-vv-as="Nombre"
						type="text"
						class="form-control"
						v-model="item.name">
					<small v-show="errors.has('name')" class="form-text text-danger">
						{{ errors.first('name') }}
					</small>
				</div>
			</template>
			<template v-else>
				{{ item.name }}
			</template>
		</td>
		<td>
			<template v-if="editMode">
				<div class="form-group" :class="{ 'has-error' : errors.has('percent') }">
					<input
						name="percent"
						v-validate="'required'"
						data-vv-as="Porcentaje"
						@change="calculateValue()"
						type="text"
						class="form-control"
						v-model="item.percent">
					<small v-show="errors.has('percent')" class="form-text text-danger">
						{{ errors.first('percent') }}
					</small>
				</div>
			</template>
			<template v-else>
				{{ item.percent }}
			</template>
		</td>
		<td>
			<template v-if="editMode">
				<div class="form-group" :class="{ 'has-error' : errors.has('value') }">
					<input
						@change="calculatePercent()"
						type="text"
						class="form-control"
						v-model="item.value">
					<small v-show="errors.has('value')" class="form-text text-danger">
						{{ errors.first('value') }}
					</small>
				</div>
			</template>
			<template v-else>
				{{ item.value }}
			</template>
		</td>
		<td>
			<template v-if="editMode">
				<div class="checkbox checkbox-success">
					<input type="checkbox" v-model="item.before_taxes"><label></label>
				</div>
			</template>
			<template v-else>
				<div class="checkbox checkbox-success">
					<input type="checkbox" v-model="item.before_taxes" disabled class="disabled"><label></label>
				</div>
			</template>
		</td>
		<td>
			<div class="btn-group pull-right">
				<template v-if="item.id">
					<button @click="destroy" type="button" class="btn btn-danger">
						<i class="fa fa-trash" aria-hidden="true"></i>
					</button>
				</template>
				<template v-else>
					<button @click="remove()" type="button" class="btn btn-default">
						<i class="fa fa-ban" aria-hidden="true"></i>
					</button>
				</template>
				<template v-if="editMode">
					<button @click="validate" type="button" class="btn btn-success">
						<i class="fa fa-floppy-o" aria-hidden="true"></i>
					</button>
				</template>
				<template v-else>
					<button @click="editMode = true" :disabled="adding" type="button" class="btn btn-default">
						<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
					</button>
				</template>
			</div>
		</td>
	</tr>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	import swal from 'sweetalert2'
	export default {
		props: ['user', 'isAuth', 'item', 'data', 'adding'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				editMode: false,
				loading: false,
			}
		},
		created() {
			this.init()
		},
		watch: {
			editMode() {
				if(this.editMode) {
					this.$emit('editModeOn')
				} else {
					this.$emit('editModeOff')
				}
			},
			'item.percent'() {
				this.item.percent = this.$options.filters.checkDecimals(this.item.percent)
			},
			'item.value'() {
				this.item.value = this.$options.filters.checkDecimals(this.item.value)
			},
			'item.before_taxes'() {
				this.calculateValue()
			}
		},
		methods: {
			init() {
				if(this.item) {
					if(!this.item.id) {
						this.editMode = true
					}
				}
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.save()
					}
					return result
				})
			},
			remove() {
				this.$emit('remove', this.item)
			},
			calculateValue() {
				if(this.item.before_taxes) {
					if(this.data.amount) {
						var total = parseFloat(this.data.amount)
					} else {
						var total = 0
					}
				} else {
					if(this.data.total) {
						var total = parseFloat(this.data.total)
					} else {
						var total = 0
					}
				}

				if(this.item.percent) {
					var percent = parseFloat(this.item.percent)
				} else {
					var percent = 0
				}
				var value = total * percent / 100
				this.item.value = parseFloat(value).toFixed(2)
			},
			calculatePercent() {
				if(this.item.before_taxes) {
					if(this.data.amount) {
						var total = parseFloat(this.data.amount)
					} else {
						var total = 0
					}
				} else {
					if(this.data.total) {
						var total = parseFloat(this.data.total)
					} else {
						var total = 0
					}
				}
				if(this.item.value) {
					var value = parseFloat(this.item.value)
					if(value > total) {
						this.item.value = total
						value = total
					}
				} else {
					var value = 0
				}
				var percent = value * 100 / total
				this.item.percent = parseFloat(percent).toFixed(2)
			},
			save() {
				if(this.item.id) {
					this.update()
				} else {
					this.store()
				}
			},
			store() {
				this.loading = true
				this.$http.post('admin/management/withholdings', this.item)
				.then(response => {
					this.loading = false
					this.$emit('close')
					this.$emit('reload')
					this.loading = false
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/management/withholdings/' + this.item.id, this.item)
				.then(response => {
					this.loading = false
					this.$emit('close')
					this.$emit('reload')
					this.loading = false
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			destroy() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.loading = true
							that.$http.delete('admin/management/withholdings/' + that.item.id)
							.then(response => {
								that.loading = false
								that.$emit('close')
								that.$emit('reload')
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
								that.loading = false
							}).catch(function(response) {
								console.log(response)
								that.loading = false
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Withholding.vue